import 'core-js'
import 'nprogress/nprogress.css'
import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App.vue'

import './router/permission'
import '@assets/styles/index.scss'
import NProgress from 'nprogress' // progress bar
import { message, Modal, notification} from 'ant-design-vue'
import printANSI from '@utils/screenLog'

Vue.use(Modal)
Vue.config.productionTip = false
Vue.prototype.$message = message
Vue.prototype.$notification = notification
NProgress.configure({showSpinner: false})
window.NProgress = NProgress


new Vue({
    render: h => h(App),
    router,
    store,
    created() {
        printANSI()
    },
}).$mount('#app')
